import { observer } from 'mobx-react-lite';
import Button from 'components/Button/Button';
import styles from './ParkScooter.module.scss';

const ParkScooter = observer(({ visible = false, onPark, onContinue }) => {

  function getOrgFee() {
    return 50;
  }

  if (!visible) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.body}>
        <div className={styles.title}>
          Please return the scooter to nearest Go X location
        </div>
        <div className={styles.text}>
          A Fee up to <strong>${getOrgFee()}</strong> may be charged if left on the street and Recovery Fee up to <strong>$100</strong> for scooters being left on or beside the beach
        </div>
        <div className={styles.buttons}>
          <Button grey onClick={onPark}>Park Here</Button>
          <Button dark onClick={onContinue}>Continue Ride</Button>
        </div>
      </div>
    </div>
  );

});

export default ParkScooter;